import { Card } from "../ui/card"
import Question from "./Question";
import { Button } from "../ui/button";
import useDoExerciseStore from "../../store/exerciseStore";
import { cn } from "../../lib/utils";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HistoryExerciseResultTable from "../table/HistoryExerciseResultTable";
import { Loader } from "../ui/loader";
export default function Exercises () {

  const location = useLocation()
  const query = new URLSearchParams(location.search);
  const exercise_id = query.get('exercise');
  const { fetchQuestions, answers, submit, submitWriting, result, questions, isLoading} = useDoExerciseStore()

  const [isStart, setIsStart] = useState(false)

  useEffect(() => {
    if (exercise_id) {

      if (isStart)
      fetchQuestions(exercise_id)
    }
  },[isStart, exercise_id])



  return (
    <div className="grid lg:grid-cols-[4fr_1fr] gap-12">
      {
      !isStart ?
      <Card className="p-8 space-y-4 text-center ">
        <h1 className="text-2xl font-black">Cùng ôn luyện nào!</h1>
        <Button variant="secondary" className="text-xl rounded-lg" onClick={() => setIsStart(true)}>Bắt đầu</Button>
        <h1 className="text-lg font-black">Lịch sử làm bài</h1>
        <HistoryExerciseResultTable />
      </Card>
        :
      <Card className="p-8 space-y-4">
      <h1 className="font-[Phudu] text-2xl font-bold">Bài tập</h1>
       {

        questions.map((question,index) => (
          <Question question={question} index={index} key={index} answer={result? result.correctAnswers[index] : null}/>
        ))}
        {!result &&
          <div className="text-center">
            {isLoading ?
            <Loader />
            :
              <Button variant="secondary" className="rounded-lg" onClick={() => {
              questions[0].type == 3 ?
              submitWriting()
              :
              submit()
            }} isLoading={isLoading}>Nộp bài</Button>}
          </div>
        }
      </Card>
      }
      <Card className="p-4 h-max space-y-4 lg:w-64 lg:fixed lg:right-8 bg-white">
        <h1 className="font-black">Tiến độ</h1>
        {
          !isStart ?
          <p className="text-gray-400 font-light italic">Bạn đã sẵn sàng chưa?</p>
          :
          <div className="flex flex-wrap gap-2">
          {answers.map((answer,index) => (
            <div className={cn(
              "size-8 rounded-md border border-gray-500 flex items-center justify-center",
              answer.answer !== "" ? "bg-blue-400 text-white border-white" : "",
              result ? "bg-gray-500 text-white" : ""
            )}>{index+1}</div>
          ))
       }

        </div>
        }
      </Card>
    </div>
  )
}
